import { render, staticRenderFns } from "./MerchantOnBoarding.vue?vue&type=template&id=c920f2aa"
import script from "./MerchantOnBoarding.vue?vue&type=script&lang=js"
export * from "./MerchantOnBoarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports